import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { COLOR } from 'config';
import PressReleasesTable from './PressReleasesTable';

const StyledContainer = styled.div`
  &:not(:last-child){
    border-bottom: 1px solid ${COLOR.borderGrey};
  }
`;

const PressReleasesItem = ({ pressrelease }) =>
  (<StyledContainer>
    <PressReleasesTable list={pressrelease.pressreleases} />
  </StyledContainer>);

PressReleasesItem.propTypes = {
  pressrelease: PropTypes.shape({
    pressreleases: PropTypes.arrayOf(PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
      dates: PropTypes.string.isRequired,
    })),
  }).isRequired,
};
export default PressReleasesItem;



// WEBPACK FOOTER //
// ./src/components/PressReleases/components/PressReleasesItem.js